export const editMutations = <const>{
	NAHRADNI_SAZBA_LAK_DRUH_SELECT_MAPPER: 'NAHRADNI_SAZBA_LAK_DRUH_SELECT_MAPPER',
};
